import { ColumnDef } from '@global-engineering-shared/gweb-material-types';

import StatusMessage from 'components/StatusMessage';
import TableCheckBox from 'components/Table/TableCheckBox';
import TableCheckBoxAll from 'components/Table/TableCheckBoxAll';
import TableDetailValue from 'components/Table/TableDetailValue';
import { getEntityIcon } from 'features/Entity/components/EntityActionBar/utils/getEntityIcon';
import { EntityType } from 'types/entityType';
import { TTableEntity } from 'types/tableEntityType';
import { LiveStatus } from 'utils/statuses';

const useEntitiesTableColumns = (): ColumnDef<TTableEntity>[] => {
  return [
    {
      id: 'checkbox',
      header: () => <TableCheckBoxAll />,
      accessorKey: 'spaceId',
      size: 40,
      cell: (context) => <TableCheckBox entityId={context.row.id} />,
    },
    {
      id: 'entityType',
      header: '',
      accessorKey: 'entityType',
      size: 40,
      cell: (context) => getEntityIcon(context.getValue() as EntityType),
    },
    {
      id: 'spaceId',
      header: 'id',
      accessorKey: 'spaceId',
      size: 104,
      cell: (context) => <TableDetailValue value={context.row.id} characterLimit={10} />,
    },
    {
      id: 'name',
      header: 'name',
      accessorKey: 'name',
      size: 225,
      meta: {
        getBodyCellProps: () => {
          return {
            style: {
              width: '100%',
            },
          };
        },
      },
      cell: (context) => <TableDetailValue value={context.row.original.name} />,
    },
    {
      id: 'environment',
      header: 'environment',
      accessorKey: 'environment',
      size: 200,
      cell: (context) => <TableDetailValue value={context.row.original.environment} />,
    },
    {
      id: 'mediaOwner',
      header: 'media owner',
      accessorKey: 'mediaOwnerName',
      size: 200,
    },
    {
      id: 'formatSize',
      header: 'format size',
      accessorKey: 'formatSize',
      size: 150,
      cell: (context) => <TableDetailValue value={context.row.original.formatSize} />,
    },
    {
      id: 'status',
      header: 'status',
      accessorKey: 'status',
      size: 120,
      cell: (context) => <StatusMessage status={context.getValue() as LiveStatus} isExpanded />,
    },
  ];
};

export default useEntitiesTableColumns;
